import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const useFetchProjectsProcurement = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get('/api/RfqHeader/get-projects-by-user', {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const writableProjects = (response.data ?? []).filter(
        (project) => !project.isComplete || (!project.isComplete && project.projectPhase !== 'Cancelled')
      );
      writableProjects.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? '', undefined, { numeric: true }));
      setProjects(writableProjects);
    } catch (err) {
      setError(err.message || 'An error occurred while fetching projects');
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { projects, loading, error };
};

export default useFetchProjectsProcurement;
